import HttpClient from "../helpers/client"
import { IResponse } from "../interfaces/response.interface"

export const SsoCreateService = () => {
    return HttpClient.init().post<IResponse<string>>(`sso`)
}